/**
 * Получает путь к микрофронту чата в зависимости от окружения
 */
export function getApplicationPath({
    appEnvironment,
    applicationName,
    cdnUrl,
}: {
    appEnvironment: string;
    applicationName: string;
    cdnUrl: string;
}) {
    if (appEnvironment === 'production') {
        return `${cdnUrl}/assets/${applicationName}`;
    }

    return `${cdnUrl}/assets/${applicationName}/${appEnvironment}`;
}

